// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Mightier than the thunder of many waters,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mightier than the breakers of the sea,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord on high is mightier.<br> </p> </div></div>";
// Exports
module.exports = code;